// extracted by mini-css-extract-plugin
export default {"wrapper":"CardHeader_wrapper__8B05q","text":"CardHeader_text__+kzS3"};